import { ColorComponent } from '../../../CustomButtons';

export const ColorCurrentlySelected = ({ currentValue }: { currentValue?: string }) => {
  if (!currentValue) return null;
  return <ColorComponent size="xs" color={currentValue} />;
};
